<template>
  <a-drawer
    :confirmLoading='confirmLoading'
    :destroyOnClose='true'
    :keyboard='false'
    :maskClosable='false'
    :visible='visible'
    width='100%'
    @close='close'>

    <template slot="title" v-if="kDesignType == 'SCHEMA_DESIGN'">
      <a-radio-group v-model="targetTab" :style="{ marginRight: '20px' }" @change="handleSizeChange">
        <a-radio-button value="schema_design">
          方案设计
        </a-radio-button>
        <a-radio-button value="form_design">
          表单设计
        </a-radio-button>
      </a-radio-group>
      {{ formTitle }}
    </template>
    
    <template slot="title" v-else>
      {{ formTitle }}
    </template>
    
    <CsimSchemaDesign ref="csimSchemaDesign" @changeFormDesignTab="changeFormDesignTab" v-on="$listeners" v-show="targetTab === 'schema_design'" />

    <k-form-design 
      v-show="targetTab === 'form_design'"
      :showHead=false
      showToolbarsText
      hideModel
      :toolbars="toolbars"
      ref="KFB" 
      @submit="handleSubmit"
      @updateTitle="updateTitle"
      @updateStatus="updateStatus"
      @reloadFormList="reloadFormList"
      @refreshForm="refresh"
      :kDesignType="kDesignType"
      :projectId="projectId"
    />
  </a-drawer>
</template>

<script>
import {
  install,
  KFormDesign,
  KFormBuild,
  KFormPreview,
  setFormDesignConfig,
  setFormBuildConfig,
  pluginManager,
  nodeSchema
} from "./index";

import CsimSchemaDesign from "./csim/schema/CsimSchemaDesign";

import { postAction, putAction } from '@/api/manage'
import { eraseUtils } from "./utils/index";

export default {
  name: 'FormDesignModel',
  components: { 
    install,
    KFormDesign,
    KFormBuild,
    KFormPreview,
    setFormDesignConfig,
    setFormBuildConfig,
    pluginManager,
    nodeSchema,
    CsimSchemaDesign
  },
  props:{
    projectId:{
      type:String,
      default:''
    },
    kDesignType:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      formTitle: '表单设计器',
      title: '表单设计器',
      status: '',
      visible: false,
      schemaGroup: [
        {
          title: "基础类型",
         // list: ["emptyCard", 'radio', 'input']
          list: ["checkbox", 'radio', 'input','table','date','time']
        },
        {
          title: "扩展类型",
          list: ['uploadFile', 'slider',  'knumber',   'datetime', 'textarea']
        }
      ],

//      toolbars: ['save', 'preview', 'exportJson', 'reset', 'close', 'undo', 'redo'],
      //  toolbars: ['save','preview','close', 'saveHistory', 'generateItemNumber'],
       toolbars: ['saveHistory','save'],

      form: {},
      model: {},
      confirmLoading: false,

      current: -1,
      cancelText: '关闭',
      okText: '确认',
      targetTab: 'schema_design',
    }
  },
  created() {
    nodeSchema.setSchemaGroup(this.schemaGroup);
  },
  methods: {
    close() {
      this.model = {}
      this.$emit('close')
      this.current = -1
      this.okText= '确认'
      this.visible = false

      this.reset();
    },
    handleCancel() {
      this.close()
    },
    handleSubmit(record) {
      const that = this;
      let formDataJson = JSON.parse(record);

      console.log('formDataJson',formDataJson);
      // Update Form
      const formData = formDataJson.form;

      if (!formData.id) {
        that.$message.warning("无可保存数据。");
        return;
      }

      that.confirmLoading = true;

      try {
        // Update Form item.
        const formItemData = eraseUtils.parseFormDesignData(formDataJson, []);

        if (this.kDesignType === 'PROJECT_FORM') {
          // Update Form
          putAction("/project/projectForm/edit", formData).then((res) => {
            if (res.success) {
              postAction('/project/projectFormItem/saveBatchFormItem', formItemData).then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.refresh();
                } else {
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.reloadFormList();
          })
        } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
          // Update Form
          putAction("/tempconfig/tempConfigForm/edit", formData).then((res) => {
            if (res.success) {
              postAction('/tempconfig/tempConfigFormItem/saveBatch', formItemData).then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.refresh();
                } else {
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.reloadFormList();
          })
        }
      } catch (ex) {
        that.$message.error(ex.message);
      }
    },
    view(form) {
      let that = this;
      this.form = form
      this.visible = true
      this.changeFormDesignTitle();
      
      if(this.targetTab === 'form_design') {
        this.$nextTick(()=>{
          that.refresh();
          that.reset();
        });
      }
    },
    updateTitle(title) {
      this.title = title;
      this.comineFormTitle();
    },
    updateStatus(status) {
      this.status = status;
      this.comineFormTitle();
    },
    reloadFormList() {
      this.$emit('reload');
    },
    comineFormTitle() {
      if (this.title) {
        this.formTitle = this.title;
      }
      if (this.title && this.status) {
        this.formTitle = this.title + " - " + this.status;
      }
    },
    refresh() {
      this.$refs.KFB.reloadSelectForm();
    },
    reset() {
      this.$refs.KFB.resetAllData();
    },
    handleSizeChange(e) {
      let targetTab = e.target.value;

      console.log(targetTab);
    },
    selectedSchema(schemaModel) {
      let that = this;
      if(this.targetTab === 'schema_design') {
        this.$nextTick(()=>{
          that.$refs.csimSchemaDesign.handleSetSchema(schemaModel);
        });
      }
    },
    changeFormDesignTab(targetTab, formInfo) {
      this.targetTab = targetTab;

      this.changeFormDesignTitle();

      let that = this;

      if(this.targetTab === 'form_design') {
        this.$nextTick(() => {
          // 获取来自 PROJECT_FORM 的表单 ID
          that.$refs.KFB.resetSeletedFormId(formInfo);
          that.$refs.KFB.reloadSelectForm();
        });
      }
    },
    setTargetTab(targetTab) {
      this.targetTab = targetTab;
    },
    changeFormDesignTitle() {
      console.log("changeFormDesignTab: ", this.targetTab);
      if(this.targetTab === 'form_design') {
        this.formTitle = '表单设计器';
        this.title = '表单设计器';
      } else if (this.targetTab === 'schema_design') {
        this.formTitle = '方案设计器';
        this.title = '方案设计器';
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.footer-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  /*background: #fff;*/
  border-radius: 0 0 4px 4px;
  z-index: 9;
  background: #F8F8F8;
}

/deep/.ant-drawer-header {
  background: #F8F8F8;
}

/deep/.ant-drawer-body {
  padding: 0px 0px 5px 16px;
}

</style>
